import { SxProps, Theme } from '@mui/material';

export const NoStoreFounPanelSX: Record<string, SxProps<Theme>> = {
	noFoundMessage: {
		margin: '10px 0',
		fontSize: '12px',
		color: 'grey.500',
	},
	noFoundImproveMessageContainer: {
		padding: '10px 0',
		backgroundColor: 'grey.50',
		img: {
			width: '90px',
			height: '90px',
		},
	},
	noFoundImproveMessage: {
		ml: '5px',
		'>p': {
			fontSize: '12px',
			color: 'grey.500',
		},
	},
	searchForMessage: {
		mb: '10px',
	},
};
